@if ({
  availableRoles: availableRoles$ | async,
  }; as content) {
  <div class="container-modal-roles">
    <form [formGroup]="form">
      @if (form.get('givenRole')?.value) {
        <div class="form-group">
          <label>
            <span class="label-content"></span>
            <input class="form-control" type="text" name="givenRole" maxlength="255" placeholder="" formControlName="givenRole" />
            <cx-form-errors [control]="form.get('givenRole')"></cx-form-errors>
          </label>
        </div>
      } @else {
        <div class="form-group">
          <label for="role">
            @for (role of content.availableRoles; track role) {
              <div class="form-check">
                <input
                  id="radio-{{ role.code }}"
                  class="form-check-input"
                  role="radio"
                  type="radio"
                  aria-checked="true"
                  [value]="role.code"
                  formControlName="role"
                  />
                  <label class="form-check-label form-radio-label" for="radio-{{ role.code }}">
                    {{ 'organization.userRoles.' + role.code | cxTranslate }}
                  </label>
                  @if (getRoleInfo(role.code)) {
                    <tooltip-icon [content]="getRoleInfo(role.code) | cxTranslate"></tooltip-icon>
                  }
                </div>
              }
              <cx-form-errors [control]="form.get('role')"></cx-form-errors>
            </label>
          </div>
        }
      </form>
    </div>
  }
